import { useEffect, useMemo, useState } from "react";
import { fetchSuburbIndicatorsTableByCity } from "../api/infoApi";

export function useSuburbIndicatorsTable(city) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    async function load() {
      if (!city) return;
      setLoading(true);
      setError(null);
      try {
        const rowsArr = await fetchSuburbIndicatorsTableByCity(city);
        if (!active) return;
        setRows(Array.isArray(rowsArr) ? rowsArr : []);
      } catch (e) {
        if (!active) return;
        setError(e);
      } finally {
        if (active) setLoading(false);
      }
    }
    load();
    return () => { active = false; };
  }, [city]);

  const data = useMemo(() => rows, [rows]);
  return { data, loading, error };
}